import { Component, OnInit, ElementRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import {
  Location,
  LocationStrategy,
  PathLocationStrategy,
} from "@angular/common";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { SpinnerService } from "app/final/spinner/spinner.service";
import { environment } from "../../../environments/environment";

declare var $: any;
// declare var pdfMake: any;

interface Certificate {
  id: number;
  email: string;
  name: string;
  year: string;
  event_name: string;
  position: string | null;
  comp_name: string | null;
  event: number | null;
}

@Component({
  selector: "app-participant",
  templateUrl: "./participant.component.html",
  styleUrls: ["./participant.component.css"],
})
export class ParticipantComponent implements OnInit {
  focus;
  focus1;
  focus2;
  email;
  year;
  certi;
  detail;
  has_checked: boolean = false;
  check: boolean = true;
  test: Date = new Date();
  private toggleButton;
  private sidebarVisible: boolean;
  private nativeElement: Node;

  constructor(
    private element: ElementRef,
    private SpinerService: SpinnerService,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;
  }

  ngOnInit() {
    if (localStorage.getItem("re") == "1") {
      window.location.reload();
      localStorage.setItem("re", "1");
    }

    localStorage.setItem("cert_pass", "2");

    this.route.queryParams.subscribe((params) => {
      console.log(params);
      this.email = params.email;
      this.year = params.year;
    });

    var body = document.getElementsByTagName("body")[0];
    body.classList.add("login-page");
    var navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName("navbar-toggle")[0];

    setTimeout(function () {
      // after 1000 ms we add the class animated to the login/register card
      $(".card").removeClass("card-hidden");
    }, 700);

    var url = environment.apiURL + "detailc/";
    var form = new FormData();
    form.append("email", this.email);
    form.append("year", this.year);
    this.http.post<any>(url, form).subscribe((data) => {
      console.log(data);
      this.certi = data;
      this.has_checked = true;
      if (this.certi.length == 0) {
        this.check = false;
      }
      console.log(this.check);
    });
  }

  ngOnDestroy() {
    var body = document.getElementsByTagName("body")[0];
    body.classList.remove("login-page");
  }

  sidebarToggle() {
    var toggleButton = this.toggleButton;
    var body = document.getElementsByTagName("body")[0];
    var sidebar = document.getElementsByClassName("navbar-collapse")[0];
    if (this.sidebarVisible == false) {
      setTimeout(function () {
        toggleButton.classList.add("toggled");
      }, 500);
      body.classList.add("nav-open");
      this.sidebarVisible = true;
    } else {
      this.toggleButton.classList.remove("toggled");
      this.sidebarVisible = false;
      body.classList.remove("nav-open");
    }
  }

  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = (error) => {
        reject(error);
      };

      img.src = url;
    });
  }

  getTextWidth(text: string, fontSize: number, fontFamily: string = 'Arial'): number {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;
    ctx.font = `${fontSize}px ${fontFamily}`;
    return ctx.measureText(text).width;
  }

  async generatePDF(detail, name, position, comp_name) {
    console.log('Received coordinates from backend - X:', detail.x, 'Y:', detail.y);
    const font_url = detail.font_file ?? detail.font_url;
    let docDefinition: any = {
      pageSize: "LETTER",
      pageOrientation: "landscape",
      pageMargins: [0, 0, 0, 0],
      content: [
        {
          image: await this.getBase64ImageFromURL(detail.file),
          absolutePosition: { x: 0, y: 0 },
          height: 612.0,
          width: 792.0,
        },
        {
          text: name,
          absolutePosition: { 
            x: detail.x - (this.getTextWidth(name, detail.font_size) / 2), 
            y: detail.y 
          },
          color: detail.font_color,
          fontSize: detail.font_size,
          bold: detail.name_bold || false,
        },
        {
          text: position || '',
          absolutePosition: { 
            x: detail.x_pos - (this.getTextWidth(position || '', detail.fs_pos) / 2), 
            y: detail.y_pos 
          },
          color: detail.color_pos || "#000000",
          fontSize: detail.fs_pos,
          bold: detail.pos_bold || false,
        },
        {
          text: comp_name || '',
          absolutePosition: { 
            x: detail.x_compname - (this.getTextWidth(comp_name || '', detail.fs_compname) / 2), 
            y: detail.y_compname 
          },
          color: detail.color_comp_name || "#000000",
          fontSize: detail.fs_compname,
          bold: detail.comp_name_bold || false,
        },
      ],
    };

    const file = "Certificate of " + name + ".pdf";
    let pdfMakeOutput;

    pdfMakeOutput = pdfMake.createPdf(docDefinition);

    pdfMakeOutput.getBlob((blob) => {
      this.SpinerService.requestEnded();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = file;
      a.click();
      URL.revokeObjectURL(url);
    });
  }

  generate(dat: Certificate) {
    console.log(dat);

    var url = environment.apiURL + "cert/";
    var form = new FormData();
    // if (dat.event == null) {
    //   alert("Some Error Occurred, Contact Admin");
    //   return;
    // }

    // form.append("year", this.year);
    this.http
      .post<any>(url, {
        event: dat.event,
        name: dat.event_name,
        year: dat.year,
      })
      .subscribe(
        (data) => {
          console.log("start");
          this.SpinerService.requestStarted();
          console.log(data);
          this.detail = data;
          this.generatePDF(this.detail, dat.name, dat.position, dat.comp_name);
        },
        (err: HttpErrorResponse) => {
          console.log(err);
          alert(err.error?.detail ?? "Some Error Occurred, Contact Admin");
        }
      );
  }
}
